import React from 'react'
import trustIcon from '../../assets/images/trust-icon.svg'
import searchIcon from '../../assets/images/eco-search-icon.svg'
import rcIcon from '../../assets/images/rc-icon.svg'
import contactCare from '../../assets/images/contact-care-img.svg'
import emailIcon from '../../assets/images/email-card-icon.svg'
import phoneIcon from '../../assets/images/phone-card-icon.svg'
import whatapp from '../../assets/images/whatsapp-card-icon.svg'
import howSell1 from '../../assets/images/howsell-1.svg'
import howSell2 from '../../assets/images/howsell-2.svg'
import howSell3 from '../../assets/images/howsell-3.svg'
import howSell4 from '../../assets/images/howsell-4.svg'
import morePhotos from '../../assets/images/more-photos-icon.svg'

const GuidelinesComponent = () => {
    return (
        <div className="parent-container">
            <div className="container">
                <h1 className="header-title">Guidelines to create a good listing</h1>

                <div className="guidelines-grid">
                    <div className="guideline-item">
                        <div className="icon-circle">
                            <img src={trustIcon} alt="Trust Enabling Tools Icon" className="icon" />
                        </div>
                        <p>Use Trust Enabling Tools</p>
                    </div>
                    <div className="guideline-item">
                        <div className="icon-circle">
                            <img src={searchIcon} alt="ECO Inspection Icon" className="icon" />
                        </div>
                        <p>Opt for ECO Inspection</p>
                    </div>
                    <div className="guideline-item">
                        <div className="icon-circle">
                            <img src={rcIcon} alt="RC & Insurance Icon" className="icon" />
                        </div>
                        <p>Have RC & Insurance Copies</p>
                    </div>
                    <div className="guideline-item">
                        <div className="icon-circle">
                            <img src={morePhotos} alt="Upload Photos Icon" className="icon" />
                        </div>
                        <p>Upload More Photos & Videos</p>
                    </div>
                </div>
                <div className="support-section row">
                    <div className="col-sm-6 pl-0">
                        <img
                            src={contactCare}
                            alt="Support Background"
                            className="support-background"
                        />
                    </div>
                    <div className="col-sm-6">
                        <div className="contact-info">
                            <h2 className="support-title">Facing any trouble?</h2>
                            <p className="support-subtitle">We are open to helping you</p>
                            <div className="contact-details">
                                <div className="contact-item">
                                    <img
                                        src={phoneIcon}
                                        alt="Phone Icon"
                                        className="contact-icon"
                                    />
                                    <p>
                                        <span>Mobile:</span> +91-8860041888
                                    </p>
                                </div>
                                <div className="contact-item">
                                    <img
                                        src={emailIcon}
                                        alt="Email Icon"
                                        className="contact-icon"
                                    />
                                    <p>
                                        <span>Email:</span>customercare@quippo.com
                                    </p>
                                </div>
                                <div className="contact-item">
                                    <img
                                        src={whatapp}
                                        alt="WhatsApp Icon"
                                        className="contact-icon"
                                    />
                                    <p>
                                        <span>WhatsApp:</span> +91-8860041888
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <h2 className="steps-title">How to Sell Equipment</h2>
                <div className="steps-grid">
                    <div className="step-item">
                        <div className="step-circle">
                            <img src={howSell1} alt="Upload Products Icon" className="step-icon" />
                        </div>
                        <p>Upload Products</p>
                    </div>
                    <div className="step-item">
                        <div className="step-circle">
                            <img src={howSell2} alt="Get Orders Icon" className="step-icon" />
                        </div>
                        <p>Get Orders</p>
                    </div>
                    <div className="step-item">
                        <div className="step-circle">
                            <img src={howSell3} alt="Fulfill Orders Icon" className="step-icon" />
                        </div>
                        <p>Fulfill Orders</p>
                    </div>
                    <div className="step-item">
                        <div className="step-circle">
                            <img src={howSell4} alt="Receive Payments Icon" className="step-icon" />
                        </div>
                        <p>Receive Payments</p>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default GuidelinesComponent
